import { device } from '@dermloop/ui/web/util';
import styled from 'styled-components';

import { ReactComponent as HeaderMobileBackground } from '../assets/wave-figure-mobile.svg';
import { ReactComponent as HeaderDesktopBackground } from '../assets/wave-figure.svg';

const StyledDesktopSvg = styled(HeaderDesktopBackground)`
  display: none;
  @media ${device.tablet} {
    display: block;
  }
  position: absolute;
  right: 0;
  height: 70vh;
  bottom: 0;
  z-index: -10;
`;

const StyledMobileSvg = styled(HeaderMobileBackground)`
  display: block;

  position: relative;
  top: -1px; //Gets rid of weird little space between divs

  @media ${device.tablet} {
    display: none;
  }
`;

export function HeaderBackground() {
  return (
    <>
      <StyledDesktopSvg />
      <StyledMobileSvg />
    </>
  );
}
